import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MenuItems } from '@core';

import { RoutePlannerComponent } from './route-planner.component';

const routes: Routes = [
    {
        path: MenuItems.routePlanner.path,
        component: RoutePlannerComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class RoutePlannerRoutingModule {}
